export class InformationFormatting {
    public static returnNameDocument(typeDocument: string) {
        if (typeDocument === 'CO1C') {
            return 'Cédula';
        } else if (typeDocument === 'CO1T') {
            return 'Tarjeta de identidad';
        } else if (typeDocument === 'CO1D') {
            return 'Carnet Diplomático';
        } else if (typeDocument === 'CO1E') {
            return 'Cédula de Extranjería';
        } else if (typeDocument === 'CO1P') {
            return 'Pasaporte';
        } else if (typeDocument === 'CO1V') {
            return 'Permiso Especial de Permanencia';
        } else if (typeDocument === 'CO1W') {
            return 'Permiso por Protección Temporal';
        } else if (typeDocument === 'CO1N') {
            return 'Nit';
        } else if (typeDocument === 'CO1X') {
            return 'Tarjeta de extranjería';
        } else if (typeDocument === 'CO1S') {
            return 'Sin identificación del exterior';
        } else if (typeDocument === 'CO1L') {
            return 'Registro Civil';
        }else {
            return ''
        }
    }

    public static returnNameDocumentPqrs(typeDocument: string) {

        if (typeDocument === 'CECI') {
            return 'Cédula';
        } else if (typeDocument === 'TADEID') {
            return 'Tarjeta de identidad';
        } else if (typeDocument === 'NI') {
            return 'Nit';
        } else if (typeDocument === 'CEDEEX') {
            return 'Cédula de Extranjería';
        } else if (typeDocument === 'PASSPORT') {
            return 'Pasaporte';
        } else if (typeDocument === 'PEESDEPE') {
            return 'Permiso Especial de Permanencia';
        } else if (typeDocument === 'PEPROTEM') {
            return 'Permiso por Protección Temporal';
        }
    }

    public static returnTypeDocPqrs(typeDocument: string){
        if (typeDocument === '2') {
            return 'CECI';
          } else if (typeDocument === '4') {
            return 'TADEID';
          } else if (typeDocument === '1') {
            return 'NI';
          } else if (typeDocument === '3') {
            return 'CEDEEX';
          } else if (typeDocument === '7') {
            return 'PASSPORT';
          } else if (typeDocument === '8') {
            return 'PEESDEPE';
          } else if (typeDocument === '9') {
            return 'PEPROTEM';
          }
    }

    public static returnNameDocumentCompany(typeDocument: string) {
        if (typeDocument === '2') {
            return 'CO1C';
        } else if (typeDocument === '1') {
            return 'CO1N';
        } else if (typeDocument === '3') {
            return 'CO1E';
        } else if (typeDocument === '7') {
            return 'CO1P';
        } else if (typeDocument === '9') {
            return 'CO1W';
        } /*else if (typeDocument === '7') {
            return 'CO1D';
        } else if (typeDocument === '7') {
            return 'CO1V';
        }*/
    }

    public static returnNumTypeDoc(typeDocument: string) {
      if (typeDocument === 'CO1C') {
          return '02';
      } else if (typeDocument === 'CO1N') {
          return '01';
      } else if (typeDocument === 'CO1E') {
          return '03';
      } else if (typeDocument === 'CO1P') {
          return '07';
      } /*else if (typeDocument === '7') {
          return 'CO1T';
      } else if (typeDocument === '7') {
          return 'CO1D';
      } else if (typeDocument === '7') {
          return 'CO1V';
      }*/
    }

    public static returnNameGender(typeGender: string) {
        if (typeGender === '1') {
            return 'Femenino (F)';
        } else if (typeGender === '2') {
            return 'Masculino (M)';
        }else {
            return ''
        }
    }

    public static returnDiscapacidad(discapacidad: string) {
        if (discapacidad === 'true') {
            return 'X';
        } else if (discapacidad === 'false') {
            return '';
        }
    }

    public static returnNameContractType(contractType: string) {
        if (contractType === '01') {
            return 'Fijo';
        } else if (contractType === '02') {
            return 'Indefinido';
        } else if (contractType === '03') {
            return 'Prestación de Servicios';
        }
    }

  public static returnNumberContractType(contractName: string) {
    if (contractName === 'Fijo') {
      return '01';
    } else if (contractName === 'Indefinido') {
      return '02';
    } else {
      return '03';
    }
  }


    public static returnNameOccupattion(occupation: string) {
        if (occupation === '01') {
            return 'Hogar';
        } else if (occupation === '02') {
            return 'Empleado';
        } else if (occupation === '03') {
            return 'Independiente';
        } else if (occupation === '04') {
            return 'Desempleado';
        } else if (occupation === '05') {
            return 'Pensionado';
        }else {
            return ''
        }
    }

    public static returnNameCivilStatus(civilStatus: string) {
        if (civilStatus === '1') {
            return 'Soltero/a';
        } else if (civilStatus === '2') {
            return 'Casado/a';
        } else if (civilStatus === '3') {
            return 'Separado/a';
        } else if (civilStatus === '4') {
            return 'Viudo/a';
        } else if (civilStatus === '5') {
            return 'Unión Libre';
        }
    }

    public static returnNameSalaryType(salary: string) {
        const salarios = {
            '01': 'Integral',
            '02': 'Fijo',
            '03': 'Variable'
        }

        return salarios[salary] || '';
    }

    public static returnNameActivityType(activity: string) {
        if (activity === '01') {
            return 'Operativo';
        } else if (activity === '02') {
            return 'Administrativo';
        } else if (activity === '03') {
            return 'Directivo';
        } else if (activity === '04') {
            return 'Staff';
        } else if (activity === '05') {
            return 'Ejecutivo';
        } else if (activity === '06') {
            return 'Profesional';
        } else if (activity === '07') {
            return 'Técnico';
        } else if (activity === '09') {
            return 'Representante Legal';
        } else if (activity === '13') {
            return 'Diplomático';
        } else if (activity === '14') {
            return 'Servicio Domestico';
        }
    }

    public static returnNameKinship(kinship: string) {
        if (kinship === '1') {
            return 'Hijo';
        } else if (kinship === '2') {
            return 'Hijastro';
        } else if (kinship === '3' || kinship === '33') {
            return 'Padre';
        } else if (kinship === '4') {
            return 'Hermano';
        }
    }

    public static returnDepartment(dpto: string) {
        switch (dpto) {
          case '11': return 'BOGOTA';
          case '15': return 'BOYACA';
          case '17': return 'CALDAS';
          case '25': return 'CUNDINAMARCA';
          case '41': return 'HUILA';
          case '50': return 'META';
          case '73': return 'TOLIMA';
        }
    }


    public static returnNameCiudad(ciudad: string){
        switch(ciudad){
            case 'CO': return 'Colombia';
            case 'AF': return 'Afganistán';
            case 'AL': return 'Albania';
            case 'DE': return 'Alemania';
            case 'AD': return 'Andorra';
            case 'AO': return 'Angola';
            case 'AI': return 'Anguila';
            case 'AQ': return 'Antártida';
            case 'AG': return 'Antigua y Barbuda';
            case 'AN': return 'Antillas Neerlandesas';
            case 'SA': return 'Arabia Saudita';
            case 'DZ': return 'Argel';
            case 'AR': return 'Argentina';
            case 'AM': return 'Armenia';
            case 'AW': return 'Aruba';
            case 'AU': return 'Australia';
            case 'AT': return 'Austria';
            case 'AZ': return 'Azerbaiyán';
            case 'BS': return 'Bahamas';
            case 'BH': return 'Bahréin';
            case 'BD': return 'Bangladesh';
            case 'BB': return 'Barbados';
            case 'BY': return 'Belarús';
            case 'BE': return 'Bélgica';
            case 'BZ': return 'Belice';
            case 'BJ': return 'Benin';
            case 'BM': return 'Bermudas';
            case 'BT': return 'Bhután';
            case 'BO': return 'Bolivia';
            case 'BA': return 'Bosnia y Herzegovina';
            case 'BW': return 'Botsuana';
            case 'BR': return 'Brasil';
            case 'BN': return 'Brunéi';
            case 'BG': return 'Bulgaria';
            case 'BF': return 'Burkina Faso';
            case 'BI': return 'Burundi';
            case 'CV': return 'Cabo Verde';
            case 'KH': return 'Camboya';
            case 'CM': return 'Camerún';
            case 'CA': return 'Canadá';
            case 'TD': return 'Chad';
            case 'CL': return 'Chile';
            case 'CN': return 'China';
            case 'CY': return 'Chipre';
            case 'VA': return 'Ciudad del Vaticano';
            case 'KM': return 'Comoros';
            case 'CG': return 'Congo';
            case 'KP': return 'Corea del Norte';
            case 'KR': return 'Corea del Sur';
            case 'CI': return 'Costa de Marfil';
            case 'CR': return 'Costa Rica';
            case 'HR': return 'Croacia';
            case 'CU': return 'Cuba';
            case 'DK': return 'Dinamarca';
            case 'DM': return 'Domínica';
            case 'EC': return 'Ecuador';
            case 'EG': return 'Egipto';
            case 'SV': return 'El Salvador';
            case 'AE': return 'Emiratos Árabes Unidos';
            case 'ER': return 'Eritrea';
            case 'SK': return 'Eslovaquia';
            case 'SI': return 'Eslovenia';
            case 'ES': return 'España';
            case 'US': return 'Estados Unidos de América';
            case 'EE': return 'Estonia';
            case 'ET': return 'Etiopía';
            case 'FJ': return 'Fiji';
            case 'PH': return 'Filipinas';
            case 'FI': return 'Finlandia';
            case 'FR': return 'Francia';
            case 'GA': return 'Gabón';
            case 'GM': return 'Gambia';
            case 'GE': return 'Georgia';
            case 'GS': return 'Georgia del Sur e Islas Sandwich del Sur';
            case 'GH': return 'Ghana';
            case 'GI': return 'Gibraltar';
            case 'GD': return 'Granada';
            case 'GR': return 'Grecia';
            case 'GL': return 'Groenlandia';
            case 'GP': return 'Guadalupe';
            case 'GU': return 'Guam';
            case 'GT': return 'Guatemala';
            case 'GY': return 'Guayana';
            case 'GF': return 'Guayana Francesa';
            case 'GG': return 'Guernsey';
            case 'GN': return 'Guinea';
            case 'GQ': return 'Guinea Ecuatorial';
            case 'GW': return 'Guinea-Bissau';
            case 'HT': return 'Haití';
            case 'HN': return 'Honduras';
            case 'HK': return 'Hong Kong';
            case 'HU': return 'Hungría';
            case 'IN': return 'India';
            case 'ID': return 'Indonesia';
            case 'IQ': return 'Irak';
            case 'IR': return 'Irán';
            case 'IE': return 'Irlanda';
            case 'BV': return 'Isla Bouvet';
            case 'IM': return 'Isla de Man';
            case 'IS': return 'Islandia';
            case 'AX': return 'Islas Áland';
            case 'KY': return 'Islas Caimán';
            case 'CX': return 'Islas Christmas';
            case 'CC': return 'Islas Cocos';
            case 'CK': return 'Islas Cook';
            case 'FO': return 'Islas Faroe';
            case 'HM': return 'Islas Heard y McDonald';
            case 'FK': return 'Islas Malvinas';
            case 'MH': return 'Islas Marshall';
            case 'NF': return 'Islas Norkfolk';
            case 'PW': return 'Islas Palaos';
            case 'PN': return 'Islas Pitcairn';
            case 'SB': return 'Islas Solomón';
            case 'SJ': return 'Islas Svalbard y Jan Mayen';
            case 'TC': return 'Islas Turcas y Caicos';
            case 'VG': return 'Islas Vírgenes Británicas';
            case 'VI': return 'Islas Vírgenes de los Estados Unidos de América';
            case 'IL': return 'Israel';
            case 'IT': return 'Italia';
            case 'JM': return 'Jamaica';
            case 'JP': return 'Japón';
            case 'JE': return 'Jersey';
            case 'JO': return 'Jordania';
            case 'KZ': return 'Kazajstán';
            case 'KE': return 'Kenia';
            case 'KG': return 'Kirguistán';
            case 'KI': return 'Kiribati';
            case 'KW': return 'Kuwait';
            case 'LA': return 'Laos';
            case 'LS': return 'Lesotho';
            case 'LV': return 'Letonia';
            case 'LB': return 'Líbano';
            case 'LR': return 'Liberia';
            case 'LY': return 'Libia';
            case 'LI': return 'Liechtenstein';
            case 'LT': return 'Lituania';
            case 'LU': return 'Luxemburgo';
            case 'MO': return 'Macao';
            case 'MK': return 'Macedonia';
            case 'MG': return 'Madagascar';
            case 'MY': return 'Malasia';
            case 'MW': return 'Malawi';
            case 'MV': return 'Maldivas';
            case 'ML': return 'Mali';
            case 'MT': return 'Malta';
            case 'MA': return 'Marruecos';
            case 'MQ': return 'Martinica';
            case 'MU': return 'Mauricio';
            case 'MR': return 'Mauritania';
            case 'YT': return 'Mayotte';
            case 'MX': return 'México';
            case 'FM': return 'Micronesia';
            case 'MD': return 'Moldova';
            case 'MC': return 'Mónaco';
            case 'MN': return 'Mongolia';
            case 'ME': return 'Montenegro';
            case 'MS': return 'Montserrat';
            case 'MZ': return 'Mozambique';
            case 'MM': return 'Myanmar';
            case 'NA': return 'Namibia';
            case 'NR': return 'Nauru';
            case 'NP': return 'Nepal';
            case 'NI': return 'Nicaragua';
            case 'NE': return 'Níger';
            case 'NG': return 'Nigeria';
            case 'NU': return 'Niue';
            case 'NO': return 'Noruega';
            case 'NC': return 'Nueva Caledonia';
            case 'NZ': return 'Nueva Zelanda';
            case 'OM': return 'Omán';
            case 'NL': return 'Países Bajos';
            case 'PK': return 'Pakistán';
            case 'PS': return 'Palestina';
            case 'PA': return 'Panamá';
            case 'PG': return 'Papúa Nueva Guinea';
            case 'PY': return 'Paraguay';
            case 'PE': return 'Perú';
            case 'PF': return 'Polinesia Francesa';
            case 'PL': return 'Polonia';
            case 'PT': return 'Portugal';
            case 'PR': return 'Puerto Rico';
            case 'QA': return 'Qatar';
            case 'GB': return 'Reino Unido';
            case 'CF': return 'República Centro-Africana';
            case 'CZ': return 'República Checa';
            case 'DO': return 'República Dominicana';
            case 'RE': return 'Reunión';
            case 'RW': return 'Ruanda';
            case 'RO': return 'Rumanía';
            case 'RU': return 'Rusia';
            case 'EH': return 'Sahara Occidental';
            case 'WS': return 'Samoa';
            case 'AS': return 'Samoa Americana';
            case 'BL': return 'San Bartolomé';
            case 'KN': return 'San Cristóbal y Nieves';
            case 'SM': return 'San Marino';
            case 'PM': return 'San Pedro y Miquelón';
            case 'VC': return 'San Vicente y las Granadinas';
            case 'SH': return 'Santa Elena';
            case 'LC': return 'Santa Lucía';
            case 'ST': return 'Santo Tomé y Príncipe';
            case 'SN': return 'Senegal';
            case 'RS': return 'Serbia y Montenegro';
            case 'SC': return 'Seychelles';
            case 'SL': return 'Sierra Leona';
            case 'SG': return 'Singapur';
            case 'SY': return 'Siria';
            case 'SO': return 'Somalia';
            case 'LK': return 'Sri Lanka';
            case 'SZ': return 'Suazilandia';
            case 'ZA': return 'Sudáfrica';
            case 'SD': return 'Sudán';
            case 'SE': return 'Suecia';
            case 'CH': return 'Suiza';
            case 'SR': return 'Surinam';
            case 'TH': return 'Tailandia';
            case 'TW': return 'Taiwán';
            case 'TH': return 'Tanzania';
            case 'TJ': return 'Tayikistán';
            case 'IO': return 'Territorio Británico del Océano Índico';
            case 'TF': return 'Territorios Australes Franceses';
            case 'TL': return 'Timor-Leste';
            case 'TG': return 'Togo';
            case 'TK': return 'Tokelau';
            case 'TO': return 'Tonga';
            case 'TT': return 'Trinidad y Tobago';
            case 'TN': return 'Túnez';
            case 'TM': return 'Turkmenistán';
            case 'TR': return 'Turquía';
            case 'TV': return 'Tuvalu';
            case 'UA': return 'Ucrania';
            case 'UG': return 'Uganda';
            case 'UY': return 'Uruguay';
            case 'UZ': return 'Uzbekistán';
            case 'VU': return 'Vanuatu';
            case 'VE': return 'Venezuela';
            case 'VN': return 'Vietnam';
            case 'WF': return 'Wallis y Futuna';
            case 'C': return 'Yemen';
            case 'DJ': return 'Yibuti';
        }
    }

    public static returnNameCity(city: string) {

        switch (city) {
          case '11001': return 'BOGOTA D.C.';
          case '15001': return 'TUNJA';
          case '15022': return 'ALMEIDA';
          case '15047': return 'AQUITANIA';
          case '15051': return 'ARCABUCO';
          case '15087': return 'BELEN';
          case '15090': return 'BERBEO';
          case '15092': return 'BETEITIVA';
          case '15097': return 'BOAVITA';
          case '15104': return 'BOYACA';
          case '15106': return 'BRICENO';
          case '15109': return 'BUENAVISTA';
          case '15114': return 'BUSBANZA';
          case '15131': return 'CALDAS';
          case '15135': return 'CAMPOHERMOSO';
          case '15162': return 'CERINZA';
          case '15172': return 'CHINAVITA';
          case '15176': return 'CHIQUINQUIRA';
          case '15180': return 'CHISCAS';
          case '15183': return 'CHITA';
          case '15185': return 'CHITARAQUE';
          case '15187': return 'CHIVATA';
          case '15189': return 'CIENEGA';
          case '15204': return 'COMBITA';
          case '15212': return 'COPER';
          case '15215': return 'CORRALES';
          case '15218': return 'COVARACHIA';
          case '15223': return 'CUBARA';
          case '15224': return 'CUCAITA';
          case '15226': return 'CUITIVA';
          case '15232': return 'CHIQUIZA';
          case '15236': return 'CHIVOR';
          case '15238': return 'DUITAMA';
          case '15244': return 'EL COCUY';
          case '15248': return 'EL ESPINO';
          case '15272': return 'FIRAVITOBA';
          case '15276': return 'FLORESTA';
          case '15293': return 'GACHANTIVA';
          case '15296': return 'GAMEZA';
          case '15299': return 'GARAGOA';
          case '15317': return 'GUACAMAYAS';
          case '15322': return 'GUATEQUE';
          case '15325': return 'GUAYATA';
          case '15332': return 'GÜICAN DE LA SIERRA';
          case '15362': return 'IZA';
          case '15367': return 'JENESANO';
          case '15368': return 'JERICO';
          case '15377': return 'LABRANZAGRANDE';
          case '15380': return 'LA CAPILLA';
          case '15401': return 'LA VICTORIA';
          case '15403': return 'LA UVITA';
          case '15407': return 'VILLA DE LEYVA';
          case '15425': return 'MACANAL';
          case '15442': return 'MARIPI';
          case '15455': return 'MIRAFLORES';
          case '15464': return 'MONGUA';
          case '15466': return 'MONGUI';
          case '15469': return 'MONIQUIRA';
          case '15476': return 'MOTAVITA';
          case '15480': return 'MUZO';
          case '15491': return 'NOBSA';
          case '15494': return 'NUEVO COLON';
          case '15500': return 'OICATA';
          case '15507': return 'OTANCHE';
          case '15511': return 'PACHAVITA';
          case '15514': return 'PAEZ';
          case '15516': return 'PAIPA';
          case '15518': return 'PAJARITO';
          case '15522': return 'PANQUEBA';
          case '15531': return 'PAUNA';
          case '15533': return 'PAYA';
          case '15537': return 'PAZ DE RIO';
          case '15542': return 'PESCA';
          case '15550': return 'PISBA';
          case '15572': return 'PUERTO BOYACA';
          case '15580': return 'QUIPAMA';
          case '15599': return 'RAMIRIQUI';
          case '15600': return 'RAQUIRA';
          case '15621': return 'RONDON';
          case '15632': return 'SABOYA';
          case '15638': return 'SACHICA';
          case '15646': return 'SAMACA';
          case '15660': return 'SAN EDUARDO';
          case '15664': return 'SAN JOSE DE PARE';
          case '15667': return 'SAN LUIS DE GACENO';
          case '15673': return 'SAN MATEO';
          case '15676': return 'SAN MIGUEL DE SEMA';
          case '15681': return 'SAN PABLO DE BORBUR';
          case '15686': return 'SANTANA';
          case '15690': return 'SANTA MARIA';
          case '15693': return 'SANTA ROSA DE VITERBO';
          case '15696': return 'SANTA SOFIA';
          case '15720': return 'SATIVANORTE';
          case '15723': return 'SATIVASUR';
          case '15740': return 'SIACHOQUE';
          case '15753': return 'SOATA';
          case '15755': return 'SOCOTA';
          case '15757': return 'SOCHA';
          case '15759': return 'SOGAMOSO';
          case '15761': return 'SOMONDOCO';
          case '15762': return 'SORA';
          case '15763': return 'SOTAQUIRA';
          case '15764': return 'SORACA';
          case '15774': return 'SUSACON';
          case '15776': return 'SUTAMARCHAN';
          case '15778': return 'SUTATENZA';
          case '15790': return 'TASCO';
          case '15798': return 'TENZA';
          case '15804': return 'TIBANA';
          case '15806': return 'TIBASOSA';
          case '15808': return 'TINJACA';
          case '15810': return 'TIPACOQUE';
          case '15814': return 'TOCA';
          case '15816': return 'TOGÜI';
          case '15820': return 'TOPAGA';
          case '15822': return 'TOTA';
          case '15832': return 'TUNUNGUA';
          case '15835': return 'TURMEQUE';
          case '15837': return 'TUTA';
          case '15839': return 'TUTAZA';
          case '15842': return 'UMBITA';
          case '15861': return 'VENTAQUEMADA';
          case '15879': return 'VIRACACHA';
          case '15897': return 'ZETAQUIRA';
          case '17001': return 'MANIZALES';
          case '17013': return 'AGUADAS';
          case '17042': return 'ANSERMA';
          case '17050': return 'ARANZAZU';
          case '17088': return 'BELALCAZAR';
          case '17174': return 'CHINCHINA';
          case '17272': return 'FILADELFIA';
          case '17380': return 'LA DORADA';
          case '17388': return 'LA MERCED';
          case '17433': return 'MANZANARES';
          case '17442': return 'MARMATO';
          case '17444': return 'MARQUETALIA';
          case '17446': return 'MARULANDA';
          case '17486': return 'NEIRA';
          case '17495': return 'NORCASIA';
          case '17513': return 'PACORA';
          case '17524': return 'PALESTINA';
          case '17541': return 'PENSILVANIA';
          case '17614': return 'RIOSUCIO';
          case '17616': return 'RISARALDA';
          case '17653': return 'SALAMINA';
          case '17662': return 'SAMANA';
          case '17665': return 'SAN JOSE';
          case '17777': return 'SUPIA';
          case '17867': return 'VICTORIA';
          case '17873': return 'VILLAMARIA';
          case '17877': return 'VITERBO';
          case '25001': return 'AGUA DE DIOS';
          case '25019': return 'ALBAN';
          case '25035': return 'ANAPOIMA';
          case '25040': return 'ANOLAIMA';
          case '25053': return 'ARBELAEZ';
          case '25086': return 'BELTRAN';
          case '25095': return 'BITUIMA';
          case '25099': return 'BOJACA';
          case '25120': return 'CABRERA';
          case '25123': return 'CACHIPAY';
          case '25126': return 'CAJICA';
          case '25148': return 'CAPARRAPI';
          case '25151': return 'CAQUEZA';
          case '25154': return 'CARMEN DE CARUPA';
          case '25168': return 'CHAGUANI';
          case '25175': return 'CHIA';
          case '25178': return 'CHIPAQUE';
          case '25181': return 'CHOACHI';
          case '25183': return 'CHOCONTA';
          case '25200': return 'COGUA';
          case '25214': return 'COTA';
          case '25224': return 'CUCUNUBA';
          case '25245': return 'EL COLEGIO';
          case '25258': return 'EL PENON';
          case '25260': return 'EL ROSAL';
          case '25269': return 'FACATATIVA';
          case '25279': return 'FOMEQUE';
          case '25281': return 'FOSCA';
          case '25286': return 'FUNZA';
          case '25288': return 'FUQUENE';
          case '25290': return 'FUSAGASUGA';
          case '25293': return 'GACHALA';
          case '25295': return 'GACHANCIPA';
          case '25297': return 'GACHETA';
          case '25299': return 'GAMA';
          case '25307': return 'GIRARDOT';
          case '25312': return 'GRANADA';
          case '25317': return 'GUACHETA';
          case '25320': return 'GUADUAS';
          case '25322': return 'GUASCA';
          case '25324': return 'GUATAQUI';
          case '25326': return 'GUATAVITA';
          case '25328': return 'GUAYABAL DE SIQUIMA';
          case '25335': return 'GUAYABETAL';
          case '25339': return 'GUTIERREZ';
          case '25368': return 'JERUSALEN';
          case '25372': return 'JUNIN';
          case '25377': return 'LA CALERA';
          case '25386': return 'LA MESA';
          case '25394': return 'LA PALMA';
          case '25398': return 'LA PENA';
          case '25402': return 'LA VEGA';
          case '25407': return 'LENGUAZAQUE';
          case '25426': return 'MACHETA';
          case '25430': return 'MADRID';
          case '25436': return 'MANTA';
          case '25438': return 'MEDINA';
          case '25473': return 'MOSQUERA';
          case '25483': return 'NARINO';
          case '25486': return 'NEMOCON';
          case '25488': return 'NILO';
          case '25489': return 'NIMAIMA';
          case '25491': return 'NOCAIMA';
          case '25506': return 'VENECIA';
          case '25513': return 'PACHO';
          case '25518': return 'PAIME';
          case '25524': return 'PANDI';
          case '25530': return 'PARATEBUENO';
          case '25535': return 'PASCA';
          case '25572': return 'PUERTO SALGAR';
          case '25580': return 'PULI';
          case '25592': return 'QUEBRADANEGRA';
          case '25594': return 'QUETAME';
          case '25596': return 'QUIPILE';
          case '25599': return 'APULO';
          case '25612': return 'RICAURTE';
          case '25645': return 'SAN ANTONIO DEL TEQUENDAMA';
          case '25649': return 'SAN BERNARDO';
          case '25653': return 'SAN CAYETANO';
          case '25658': return 'SAN FRANCISCO';
          case '25662': return 'SAN JUAN DE RIOSECO';
          case '25718': return 'SASAIMA';
          case '25736': return 'SESQUILE';
          case '25740': return 'SIBATE';
          case '25743': return 'SILVANIA';
          case '25745': return 'SIMIJACA';
          case '25754': return 'SOACHA';
          case '25758': return 'SOPO';
          case '25769': return 'SUBACHOQUE';
          case '25772': return 'SUESCA';
          case '25777': return 'SUPATA';
          case '25779': return 'SUSA';
          case '25781': return 'SUTATAUSA';
          case '25785': return 'TABIO';
          case '25793': return 'TAUSA';
          case '25797': return 'TENA';
          case '25799': return 'TENJO';
          case '25805': return 'TIBACUY';
          case '25807': return 'TIBIRITA';
          case '25815': return 'TOCAIMA';
          case '25817': return 'TOCANCIPA';
          case '25823': return 'TOPAIPI';
          case '25839': return 'UBALA';
          case '25841': return 'UBAQUE';
          case '25843': return 'VILLA DE SAN DIEGO DE UBATE';
          case '25845': return 'UNE';
          case '25851': return 'UTICA';
          case '25862': return 'VERGARA';
          case '25867': return 'VIANI';
          case '25871': return 'VILLAGOMEZ';
          case '25873': return 'VILLAPINZON';
          case '25875': return 'VILLETA';
          case '25878': return 'VIOTA';
          case '25885': return 'YACOPI';
          case '25898': return 'ZIPACON';
          case '25899': return 'ZIPAQUIRA';
          case '41001': return 'NEIVA';
          case '41006': return 'ACEVEDO';
          case '41013': return 'AGRADO';
          case '41016': return 'AIPE';
          case '41020': return 'ALGECIRAS';
          case '41026': return 'ALTAMIRA';
          case '41078': return 'BARAYA';
          case '41132': return 'CAMPOALEGRE';
          case '41206': return 'COLOMBIA';
          case '41244': return 'ELIAS';
          case '41298': return 'GARZON';
          case '41306': return 'GIGANTE';
          case '41319': return 'GUADALUPE';
          case '41349': return 'HOBO';
          case '41357': return 'IQUIRA';
          case '41359': return 'ISNOS';
          case '41378': return 'LA ARGENTINA';
          case '41396': return 'LA PLATA';
          case '41483': return 'NATAGA';
          case '41503': return 'OPORAPA';
          case '41518': return 'PAICOL';
          case '41524': return 'PALERMO';
          case '41530': return 'PALESTINA';
          case '41548': return 'PITAL';
          case '41551': return 'PITALITO';
          case '41615': return 'RIVERA';
          case '41660': return 'SALADOBLANCO';
          case '41668': return 'SAN AGUSTIN';
          case '41676': return 'SANTA MARIA';
          case '41770': return 'SUAZA';
          case '41791': return 'TARQUI';
          case '41797': return 'TESALIA';
          case '41799': return 'TELLO';
          case '41801': return 'TERUEL';
          case '41807': return 'TIMANA';
          case '41872': return 'VILLAVIEJA';
          case '41885': return 'YAGUARA';
          case '50001': return 'VILLAVICENCIO';
          case '50006': return 'ACACIAS';
          case '50110': return 'BARRANCA DE UPIA';
          case '50124': return 'CABUYARO';
          case '50150': return 'CASTILLA LA NUEVA';
          case '50223': return 'CUBARRAL';
          case '50226': return 'CUMARAL';
          case '50245': return 'EL CALVARIO';
          case '50251': return 'EL CASTILLO';
          case '50270': return 'EL DORADO';
          case '50287': return 'FUENTE DE ORO';
          case '50313': return 'GRANADA';
          case '50318': return 'GUAMAL';
          case '50325': return 'MAPIRIPAN';
          case '50330': return 'MESETAS';
          case '50350': return 'LA MACARENA';
          case '50370': return 'URIBE';
          case '50400': return 'LEJANIAS';
          case '50450': return 'PUERTO CONCORDIA';
          case '50568': return 'PUERTO GAITAN';
          case '50573': return 'PUERTO LOPEZ';
          case '50577': return 'PUERTO LLERAS';
          case '50590': return 'PUERTO RICO';
          case '50606': return 'RESTREPO';
          case '50680': return 'SAN CARLOS DE GUAROA';
          case '50683': return 'SAN JUAN DE ARAMA';
          case '50686': return 'SAN JUANITO';
          case '50689': return 'SAN MARTIN';
          case '50711': return 'VISTAHERMOSA';
          case '73001': return 'IBAGUE';
          case '73024': return 'ALPUJARRA';
          case '73026': return 'ALVARADO';
          case '73030': return 'AMBALEMA';
          case '73043': return 'ANZOATEGUI';
          case '73055': return 'ARMERO';
          case '73067': return 'ATACO';
          case '73124': return 'CAJAMARCA';
          case '73148': return 'CARMEN DE APICALA';
          case '73152': return 'CASABIANCA';
          case '73168': return 'CHAPARRAL';
          case '73200': return 'COELLO';
          case '73217': return 'COYAIMA';
          case '73226': return 'CUNDAY';
          case '73236': return 'DOLORES';
          case '73268': return 'ESPINAL';
          case '73270': return 'FALAN';
          case '73275': return 'FLANDES';
          case '73283': return 'FRESNO';
          case '73319': return 'GUAMO';
          case '73347': return 'HERVEO';
          case '73349': return 'HONDA';
          case '73352': return 'ICONONZO';
          case '73408': return 'LERIDA';
          case '73411': return 'LIBANO';
          case '73443': return 'SAN SEBASTIAN DE MARIQUITA';
          case '73449': return 'MELGAR';
          case '73461': return 'MURILLO';
          case '73483': return 'NATAGAIMA';
          case '73504': return 'ORTEGA';
          case '73520': return 'PALOCABILDO';
          case '73547': return 'PIEDRAS';
          case '73555': return 'PLANADAS';
          case '73563': return 'PRADO';
          case '73585': return 'PURIFICACION';
          case '73616': return 'RIOBLANCO';
          case '73622': return 'RONCESVALLES';
          case '73624': return 'ROVIRA';
          case '73671': return 'SALDANA';
          case '73675': return 'SAN ANTONIO';
          case '73678': return 'SAN LUIS';
          case '73686': return 'SANTA ISABEL';
          case '73770': return 'SUAREZ';
          case '73854': return 'VALLE DE SAN JUAN';
          case '73861': return 'VENADILLO';
          case '73870': return 'VILLAHERMOSA';
          case '73873': return 'VILLARRICA';

        }
      }
}

